export enum SubscriptionHistoryType {
  AccountCreated = 0,
  TrialStarted = 1,
  TrialExtended = 2,
  ExtendTimeRequest = 3,
  TimeApproved = 4,
  AccountSuspended = 5,
  ConvertedSubscription = 6,
  SubscriptionChanged = 7,
}

export interface HistoryEvent {
  id: string;
  type: SubscriptionHistoryType;
  icon: "check" | "user";
  details: {
    name?: string;
    date?: string;
    days?: string;
    expiringDate?: string;
    text?: string;
    subscriptionName?: string;
    variant?: "converted" | "changed";
    byUser?: string;
    reason?: string;
  };
}